// phonics_data_uu.js
// Song/Chant 来源: F:\17talkxyz\Phonics_AtoZ\AtoZ_mp4\Uu.mp4 (00:11 - 01:20)
// Story 1/2/3 来源: F:\17talkxyz\Phonics_AtoZ\Letter Uu\Uu1/2/3.mp4 (完整)

const MEDIA_BASE = '/media/phonics/uu';

const letterDataUu = {
  letter: 'Uu',
  coverBg: `${MEDIA_BASE}/image1.jpeg`,
  coverPoster: `${MEDIA_BASE}/Uu.png`,

  songVideo: {
    src: `${MEDIA_BASE}/Uu.mp4`,
    poster: `${MEDIA_BASE}/Uu.png`,
    startTime: 11,
    endTime: 80,
  },

  wordVideos: [
    // 4格词汇: 上左=umbrella, 上右=uncle, 下左=under, 下右=up
    // poster 按实际位置对应（image编号 = PPT中该词汇的封面图）
    { src: `${MEDIA_BASE}/video_s3_word3.mp4`, poster: `${MEDIA_BASE}/image9.png`, word: 'umbrella', wordCn: '伞' },
    { src: `${MEDIA_BASE}/video_s3_word2.mp4`, poster: `${MEDIA_BASE}/image8.png`, word: 'uncle', wordCn: '叔叔' },
    { src: `${MEDIA_BASE}/video_s3_word4.mp4`, poster: `${MEDIA_BASE}/image10.png`, word: 'under', wordCn: '在...下面' },
    { src: `${MEDIA_BASE}/video_s3_word1.mp4`, poster: `${MEDIA_BASE}/image11.png`, word: 'up', wordCn: '向上' },
  ],

  storySections: [
    {
      label: 'Learn the Story (1)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_1.mp4`, poster: `${MEDIA_BASE}/image13.png` },
      ],
      splitAt: 4,
      lines: [
        { en: 'rain',       cn: '下雨',         audioEn: `${MEDIA_BASE}/w_en_rain.mp3`,      audioCn: `${MEDIA_BASE}/w_cn_rain.mp3` },
        { en: 'raining',    cn: '正在下雨',      audioEn: `${MEDIA_BASE}/w_en_raining.mp3`,   audioCn: `${MEDIA_BASE}/w_cn_raining.mp3` },
        { en: 'need',       cn: '需要',          audioEn: `${MEDIA_BASE}/w_en_need.mp3`,       audioCn: `${MEDIA_BASE}/w_cn_need.mp3` },
        { en: 'we',         cn: '我们',          audioEn: `${MEDIA_BASE}/w_en_we.mp3`,         audioCn: `${MEDIA_BASE}/w_cn_we.mp3` },
        { en: "It's raining. We need an umbrella.",  cn: '下雨了。我们需要一把伞。',         audioEn: `${MEDIA_BASE}/story1_en_1.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3` },
        { en: "Uncle! Do you have an umbrella?",   cn: '你有一把伞吗？',                     audioEn: `${MEDIA_BASE}/story1_en_2.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3` },
        { en: "Uh-huh. Yes, I do.",                cn: '嗯哼。有的。',                        audioEn: `${MEDIA_BASE}/story1_en_3.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3` },
      ],
    },
    {
      label: 'Learn the Story (2)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_2.mp4`, poster: `${MEDIA_BASE}/image14.png` },
      ],
      splitAt: 2,
      lines: [
        { en: 'come',  cn: '来',             audioEn: `${MEDIA_BASE}/w_en_come.mp3`,    audioCn: `${MEDIA_BASE}/w_cn_come.mp3` },
        { en: 'under', cn: '在...下面',      audioEn: `${MEDIA_BASE}/w_en_under.mp3`,   audioCn: `${MEDIA_BASE}/w_cn_under.mp3` },
        { en: "Uncle. We need an umbrella.",           cn: '叔叔。我们需要一把伞。',  audioEn: `${MEDIA_BASE}/story2_en_1.mp3`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3` },
        { en: "Come under my umbrella.",               cn: '到我的伞下面来。',       audioEn: `${MEDIA_BASE}/story2_en_2.mp3`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3` },
        { en: "Uh-huh.",                               cn: '嗯哼。',                 audioEn: `${MEDIA_BASE}/story2_en_3.mp3`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3` },
      ],
    },
    {
      label: 'Learn the Story (3)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_3.mp4`, poster: `${MEDIA_BASE}/image15.png` },
      ],
      splitAt: 0,
      lines: [
        { en: "Uncle! It's nice under the umbrella.", cn: '叔叔！伞下面真舒服。',        audioEn: `${MEDIA_BASE}/story3_en_1.mp3`, audioCn: `${MEDIA_BASE}/story3_cn_1.mp3` },
        { en: "Uh-huh. Yes, it is.",                  cn: '嗯哼。是的。',               audioEn: `${MEDIA_BASE}/story3_en_2.mp3`, audioCn: `${MEDIA_BASE}/story3_cn_2.mp3` },
        { en: "Uncle! Where are we going?",           cn: '叔叔！我们正在去哪里？',     audioEn: `${MEDIA_BASE}/story3_en_3.mp3`, audioCn: `${MEDIA_BASE}/story3_cn_3.mp3` },
        { en: "Uh-oh! We're going up!",               cn: '哎呀！我们要升上去了！',     audioEn: `${MEDIA_BASE}/story3_en_4.mp3`, audioCn: `${MEDIA_BASE}/story3_cn_4.mp3` },
      ],
    },
  ],
};

export default letterDataUu;
